<template>
  <a-spin :spinning="spinning" size="large">
    <div class="dynamic">
      <template v-if="!!infoData">
        <p class="title">案情通告：</p>
        <ul class="info-list">
          <template v-if="infoData.length > 0">
            <li v-for="list in infoData" :key="list.id">
              <p>{{ list.updated_at }}</p>
              <p>{{ list.content }}</p>
            </li>
          </template>
          <template v-else>
            <li>暂无数据</li>
          </template>
        </ul>
        <div class="btn">
          <a-button
            type="primary"
            @click="getInfoData"
            :loading="infoLoadMoreStatus"
            v-if="haveMoreInfo"
          >查看更多</a-button>
        </div>
      </template>
      <template v-if="!!dynamicData">
        <p class="title">职位动态：</p>
        <ul class="dynamic-list">
          <template v-if="dynamicData.length > 0">
            <li v-for="list in dynamicData" :key="list.id">
              <a-row class="row" type="flex" justify="space-between" align="middle">
                <a-col>
                  <span class="t1">{{ list.context.message }}</span>
                </a-col>
                <a-col>
                  <span class="time">反馈时间：{{ list.created_at }}</span>
                </a-col>
              </a-row>
              <p>
                <span class="reason" v-show="list.context.reason">
                  拒绝理由:
                  <span v-for="(arr, index) in list.context.reason" :key="index">{{ arr }}</span>
                </span>
                {{ list.reason }}
              </p>
            </li>
          </template>
          <template v-else>
            <li>暂无数据</li>
          </template>
        </ul>
        <div class="btn">
          <a-button
            type="primary"
            @click="getDynamicData"
            :loading="dynamicLoadMoreStatus"
            v-if="haveMoreDynamic"
          >查看更多</a-button>
        </div>
      </template>
    </div>
  </a-spin>
</template>

<script>
import Api from "@/api";
export default {
  name: "postDynamic",
  props: ["id"],
  data() {
    return {
      infoData: undefined,
      dynamicData: undefined,
      spinning: false,
      infoLoadMoreStatus: false,
      dynamicLoadMoreStatus: false,
      infoPage: 0,
      dynamicPage: 0,
      infoTotal: 0,
      dynamicTotal: 0
    };
  },
  created() {
    this.spinning = true;
    this.getInfoData();
    this.getDynamicData();
  },
  computed: {
    haveMoreInfo() {
      let more = this.infoTotal - this.infoPage * 10;
      return more > 0;
    },
    haveMoreDynamic() {
      let more = this.dynamicTotal - this.dynamicPage * 10;
      return more > 0;
    }
  },
  methods: {
    getInfoData() {
      this.infoPage++;
      let params = {
        job_id: this.id,
        page: this.infoPage,
        limit: 10
      };
      if (this.infoPage > 1) {
        this.infoLoadMoreStatus = true;
      }
      Api.position
        .getNotice(params)
        .then(res => {
          this.infoTotal = res.total;
          if (this.infoPage > 1) {
            this.infoData = this.infoData.concat(res.list);
          } else {
            this.infoData = res.list;
          }
        })
        .finally(() => {
          this.infoLoadMoreStatus = false;
          this.spinning = false;
        });
    },
    getDynamicData() {
      this.dynamicPage++;
      let params = {
        job_id: this.id,
        page: this.dynamicPage,
        limit: 10
      };
      if (this.dynamicPage > 1) {
        this.dynamicLoadMoreStatus = true;
      }
      Api.position
        .getFeed(params)
        .then(res => {
          this.dynamicTotal = res.total;
          if (this.dynamicPage > 1) {
            this.dynamicData = this.dynamicData.concat(res.list);
          } else {
            this.dynamicData = res.list;
          }
        })
        .finally(() => {
          this.dynamicLoadMoreStatus = false;
          this.spinning = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.dynamic {
  text-align: center;
  padding: 25px 0;
  min-height: 400px;
  .title {
    text-align: left;
    font-weight: bold;
    font-size: 16px;
  }
  .btn {
    text-align: center;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .info-list {
    text-align: left;
    li {
      padding-bottom: 8x;
      p {
        color: #666;
        &:first-child {
          color: #999;
          margin-bottom: 6px;
        }
      }
    }
  }
  .dynamic-list {
    text-align: left;
    li {
      margin-bottom: 35px;
      p {
        margin-top: 5px;
      }
    }
    span {
      &.t1 {
        color: #333;
      }
      &.time {
        color: #999;
      }
      &.reason {
        color: #f6b502;
      }
    }
  }
}
</style>
